import { action } from 'satcheljs';
import SmimeViewState from '../store/schema/SmimeViewState';

/**
 * Action which is disposed to save the signing certRawData
 * in ComposeViewState.
 */
export default action(
    'saveSigningCertificate',
    (smimeViewState: SmimeViewState, signingCertRawData: string) => ({
        smimeViewState,
        signingCertRawData,
    })
);
